import AppRoutes from '../../../config/AppRoutes';

const tabList = {
  esg: [
    {
      label: 'Question',
      idFieldName: 'questionId',
      // SAVED ITEM LIST START HERE
      favAPIService: 'fetchSavedQuestion',
      saveItemDeleteAPIService: 'deleteSavedQuestion',
      savedItemTitle: 'Question ID', // that is tabs title with ID
      saveItemTableName: 'esg_question', // table name to access object or save item
      savedItemTableKey: 'name', // key name to represent topic which is show in tab
      // REPORTED ITEM LIST START HERE
      reportAPIService: 'fetchReportedQuestion',
      reportedItemTableKey: 'comment',
      reportDeleteAPIService: 'deleteReportedQuestion',
      // VIEW ITEM LIST START HERE
      viewItemAPIService: 'redirectToQuestion',
      redirectionPath: AppRoutes.ESG_QUESTION_BANK_VIEW_QUE,
      // EDIT REPORT LIST START HERE
      editAPIService: 'updateReportedQuestion',
    },
    {
      label: 'Video',
      //* SAVED ITEM LIST START HERE
      favAPIService: 'fetchSavedVideos',
      saveItemDeleteAPIService: 'deleteSavedVideo',
      savedItemTitle: 'Video ID', // that is tabs title with ID
      saveItemTableName: 'esg_video', // table name to access object or save item
      savedItemTableKey: 'title', // key name to represent topic which is show in tab
      //* REPORTED ITEM LIST START HERE
      reportAPIService: 'fetchReportedVideos',
      reportedItemTableKey: 'comment',
      reportDeleteAPIService: 'deleteReportedVideo',
      //* VIEW ITEM LIST START HERE
      viewItemAPIService: 'redirectToVideo',
      redirectionPath: AppRoutes.ESG_VIDEO_LESSON,
      //* EDIT REPORT LIST START HERE
      editAPIService: 'updateReportedVideo',
    },

    {
      label: 'Mocks',
      reportAPIService: 'fetchCBTReportedQuestion',
      savedItemTitle: 'CBT Question ID',
      saveItemTableName: 'esg_cbt_question',
      savedItemTableKey: 'name', // key name to represent topic which is show in tab
      reportedItemTableKey: 'comment',
      viewItemAPIService: 'redirectToCBTQuestion',
      redirectionPath: AppRoutes.ESG_CBT_FINISH_PAGE,
      reportDeleteAPIService: 'deleteCBTReportedQuestion',
      // EDIT REPORT LIST START HERE
      editAPIService: 'updateReportedCBTQuestion',
    },
  ],
};

export default tabList;



// WEBPACK FOOTER //
// ./src/views/ESG/Dashboard/Config/tabList.js